"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeUrlSectionItem = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2023 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
exports.AttributeUrlSectionItem = function (_a) {
    var item = _a.item, onClickHandler = _a.onClickHandler, isSelected = _a.isSelected;
    var className = classnames_1.default("gd-list-item gd-menu-item gd-drill-to-attribute-url-option s-drill-to-attribute-url-option gd-icon-hyperlink-warning", {
        "is-selected": isSelected,
    });
    var onClick = react_1.useCallback(function () {
        if (!onClickHandler) {
            return;
        }
        onClickHandler(item);
    }, [item, onClickHandler]);
    return (react_1.default.createElement("div", { className: className, onClick: onClick },
        react_1.default.createElement("span", { className: "gd-parameter-title" }, item.attribute.title),
        react_1.default.createElement("span", { className: "addon" },
            "(",
            item.displayForm.title,
            ")")));
};
//# sourceMappingURL=AttributeUrlSectionItem.js.map